/* ══════════════════════════════════════════
   Login.jsx
══════════════════════════════════════════ */
import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import './Auth.css';

const IconMail    = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/><polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconLock    = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEye     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconEyeOff  = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconArrow   = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

const LogoComunicar = ({ height = 44 }) => (
  <img
    src="/images/logo_centro.png"
    alt="Comunicar"
    style={{ height: height, width: 'auto', display: 'block' }}
  />
);

export default function Login() {
  const { login }   = useAuthUser();
  const navigate    = useNavigate();
  const location    = useLocation();
  const params = new URLSearchParams(location.search);
  const from = params.get('redirect') || location.state?.from || '/mi-cuenta';

  const [form,     setForm]     = useState({ email:'', password:'' });
  const [verPass,  setVerPass]  = useState(false);
  const [error,    setError]    = useState('');
  const [cargando, setCargando] = useState(false);

  const setF = (k,v) => setForm(f=>({...f,[k]:v}));

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (!form.email || !form.password) { setError('Completa todos los campos'); return; }
    setCargando(true);
    try {
      await login(form.email, form.password);
      navigate(from, { replace: true });
    } catch(err) {
      setError(err.message || 'Error al iniciar sesión');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg">
        <div className="auth-blob auth-blob--a"/>
        <div className="auth-blob auth-blob--b"/>
        <div className="auth-grid" aria-hidden="true"/>
      </div>

      <div className="auth-container">

        {/* Logo real */}
        <Link to="/" className="auth-logo">
          <LogoComunicar height={52}/>
        </Link>

        <div className="auth-card">
          <div className="auth-card__head">
            <h1>Iniciar sesión</h1>
            <p>Accede a tu cuenta para ver tus recursos, formaciones y puntos.</p>
          </div>

          {error && <div className="auth-error">{error}</div>}

          <form className="auth-form" onSubmit={handleSubmit} noValidate>

            <div className="auth-field">
              <label>Correo electrónico</label>
              <div className="auth-field__wrap">
                <span className="auth-field__icon"><IconMail/></span>
                <input
                  type="email" placeholder="tu@correo.com"
                  value={form.email}
                  onChange={e=>setF('email',e.target.value)}
                  autoComplete="email" required
                />
              </div>
            </div>

            <div className="auth-field">
              <label>
                Contraseña
                <Link to="/recuperar-password" className="auth-field__link">¿Olvidaste tu contraseña?</Link>
              </label>
              <div className="auth-field__wrap">
                <span className="auth-field__icon"><IconLock/></span>
                <input
                  type={verPass?'text':'password'}
                  placeholder="Tu contraseña"
                  value={form.password}
                  onChange={e=>setF('password',e.target.value)}
                  autoComplete="current-password" required
                />
                <button type="button" className="auth-field__toggle" onClick={()=>setVerPass(v=>!v)}>
                  {verPass?<IconEyeOff/>:<IconEye/>}
                </button>
              </div>
            </div>

            <button type="submit" className="auth-submit" disabled={cargando}>
              {cargando ? <><IconSpinner/> Entrando…</> : <>Iniciar sesión <IconArrow/></>}
            </button>

          </form>

          <div className="auth-footer">
            <p>¿No tienes cuenta? <Link to="/registro">Regístrate gratis</Link></p>
            <br/>
            <Link to="/" className="auth-back">
              <svg viewBox="0 0 20 20" fill="none" width="14" height="14">
                <path d="M16 10H4M9 14l-5-4 5-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Volver al inicio
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}